var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { createPortal } from "react-dom";
import { Container } from "./Container";
import { LayerView } from "./LayerView";
export function Modal(_a) {
    var children = _a.children, container = _a.container, restProps = __rest(_a, ["children", "container"]);
    var _b = __read(useMemo(function () {
        if (container)
            return [container, false];
        return [new Container(), true];
    }, [container]), 2), finalContainer = _b[0], shouldRemoveContainer = _b[1];
    var portal = createPortal(_jsx(LayerView, __assign({}, restProps, { renderContent: function () { return children; } })), finalContainer.rootElem);
    useEffect(function () {
        return function () {
            if (shouldRemoveContainer)
                finalContainer.dispose();
        };
    }, [shouldRemoveContainer]);
    return portal;
}
